export default "__VITE_ASSET__Cnoz8moy__"